module.exports = __webpack_public_path__ + "img/t2-c23.01c1ff5f.png";